import React from 'react'
import Commoninformation from '../Pagehome/Commoninformation'
import { Link } from 'react-router-dom'
import Icons from '../../components/icons';

const Termscondition = () => {
    return (
        <>
            {/* <Commoninformation /> */}
            <div className='container-lg'>
                {/*breadcrunb start*/}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li><span><Icons.SlashSvg /></span></li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Terms Of Conditions
                        </li>
                    </ol>
                </nav>
                {/*breadcrunb End*/}
            </div>
            <div className='innerpages-section padding-50'>
                <div className='container-lg'>
                    <div className='flex-box justify-center mb-4'>
                        <div className='custom-heading  text-center '>
                            Terms Of Conditions
                        </div>
                    </div>

                    <div className='inp-inner'>
                        <div className='custom-text ct-small'>
                            <strong>Welcome to Forbes.</strong> By visiting or interacting with this platform, you agree to follow these rules and guidelines. Please read them carefully before using our services.
                        </div>

                        <div className='custom-heading ch-medium'>1. Access and Use</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>Forbes provides verified updates, features, and insights focused on the <strong>United Kingdom</strong>.</li>
                            <li>Users should browse responsibly for personal or informational purposes only.</li>
                            <li>Attempts to disrupt, hack, or misuse the platform are strictly prohibited.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>2. Ownership and Copyright</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>All content including articles, multimedia, and graphics is owned exclusively by <strong>Forbes</strong>.</li>
                            <li>Copying, distributing, or using content commercially without prior approval is forbidden.</li>
                            <li>Sharing is permitted only with proper attribution and a link to the original source.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>3. User Conduct</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>Users must refrain from submitting false, offensive, or unlawful content.</li>
                            <li>Comments or materials promoting spam, harassment, or illegal actions will be removed immediately.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>4. Third-Party Links</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>The site may contain links to external websites.</li>
                            <li>Forbes is <strong>not responsible</strong> for their content, accuracy, or privacy practices. Users should review their policies independently.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>5. Liability Limitations</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>While Forbes strives for accuracy, we are <strong>not liable</strong> for any losses, damages, or consequences arising from use or interpretation of content.</li>
                        </ul>

                        <div className='custom-heading ch-medium'>6. Updates and Revisions</div>
                        <ul className='custom-text ct-small custom-list-style'>
                            <li>These terms may be revised from time to time to reflect updates in law, technology, or business practices.</li>
                            <li>Continued access to the platform constitutes acceptance of the latest version.</li>
                        </ul>

                        <div className='custom-text ct-small' style={{marginTop: '28px', fontWeight: 'bold', textAlign: 'center'}}>
                            By using <strong>Forbes</strong>, you acknowledge and accept these rules and support our commitment to <strong>trusted, transparent, and high-quality coverage throughout the UK.</strong>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Termscondition